export enum Subjects {
  ALL = 'all',
  DEV_TOOLS = 'dev-tools',
  ACCOUNTS = 'accounts',
  OWN_ACCOUNT = 'own-account', // This is a special case for the account admin
  ASSIGNED_ACCOUNTS = 'assigned-accounts', // This is a special case for the multiple accounts admin
  RESELLERS = 'resellers',
  RESELLERS_DOMAIN_CONFIG = 'resellers-domain-config',
  USERS = 'users',
  ROLES = 'roles',
  GROUPS = 'groups',
  BRANCHES = 'branches',
  AD_SYNC = 'ad-sync',
  FILES = 'files',
  EMAIL_TEMPLATES = 'email-templates',
  CAMPAIGNS = 'campaigns',
  CAMPAIGNS_MIGRATION = 'campaigns-migration',
  SENDING_PROFILES = 'sending-profiles',
  PAGES = 'pages',
  ACCOUNT_CAMPAIGNS_SUMMARY = 'account-campaigns-summary',
  CAMPAIGN_RESULTS = 'campaign-results',
  ADMIN_DASHBOARD = 'admin-dashboard',
  LEARNER_DASHBOARD = 'learner-dashboard',
  SYSTEM_SETTINGS = 'system-settings',
  ME = 'me',
  COURSES = 'courses',
  ENROLLED_COURSES = 'enrolled-courses',
  ATTEMPTS = 'attempts',
  OWN_ATTEMPTS = 'own-attempts',
  COURSE_ACCOUNT_AVAILABILITY = 'course-account-availability',
  COURSE_ACCOUNT_SCHEDULES = 'course-account-schedules',
  COURSE_BRANCH_SCHEDULES = 'course-branch-schedules',
  COURSE_USER_SCHEDULES = 'course-user-schedules',
  ACCOUNT_REPORTS = 'account-reports',
  ACCOUNT_MIGRATION = 'account-migration',
  ACCOUNT_SSO = 'account-sso',
  USERS_MIGRATION = 'users-migration',
  HUBSPOT_ACCOUNT_LINK = 'hubspot-account-link',
  COURSE_GROUP_SCHEDULES = 'course-group-schedules',
  COURSE_FORCE_COMPLETE = 'course-force-complete',
  COURSE_PLANNER = 'course-planner',
  SECURITY_CULTURE = 'security-culture',
  TEST_EMAIL = 'test-email',
  FEATURE_FLAGS = 'feature-flags',
  ACCOUNT_FEATURE_FLAGS = 'account-feature-flags',
  SUPPRESSED_DOMAINS = 'suppressed-domains',
  FALSE_POSITIVE_IPS = 'false-positive-ips',
  INDIVIDUAL_AI_CAMPAIGNS = 'individual-ai-campaigns',

  // Feature
  OUTLOOK_PHISHING_EMAIL_REPORTING = 'outlook-phishing-email-reporting',
  EMAIL_OPEN_EVENTS = 'email-open-events',
  SKIP_COURSE_SURVEY = 'skip-course-survey',
  TRY_FOR_FREE = 'try-for-free',
  SECURITY_CULTURE_TYPEFORM_INTEGRATION = 'security-culture-typeform-integration',
  SECURITY_CULTURE_DASHBOARD = 'security-culture-dashboard',
  SECURITY_CULTURE_DASHBOARD_NON_CUSTOMERS = 'security-culture-dashboard-non-customers',
  SECURITY_CULTURE_DEMO_REPORT = 'security-culture-demo-report',
  AI_PHISHING_CAMPAIGN_RECOMMENDATION = 'ai-phishing-campaign-recommendation',
  AUTO_PHISHING_BANNER = 'auto-phishing-banner',
  ADMIN_TASKS = 'admin-tasks',
  LEARNER_DASHBOARD_ACCESSIBILITY = 'learner-dashboard-accessibility',
  AI_PHISHING_TRAINING = 'ai-phishing-training',
  SELF_SERVICE_AUTO_PHISHING = 'self-service-auto-phishing',
  ACCOUNT_DATA_REMOVAL = 'account-data-removal',
  RECON_AI_GENERATED_CAMPAIGN_TEMPLATE = 'recon-ai-generated-campaign-template',
  ACCOUNTS_SYSTEM_PAGE = 'accounts-system-page',
  ACCOUNT_INTERNAL_TAB = 'account-internal-tab',
  ACCOUNT_CONTENT_TAB = 'account-content-tab',
  ACCOUNT_MATERIALS_TAB = 'account-materials-tab',
  ACCOUNT_FEATURES_TAB = 'account-features-tab',
  PHISHING_SIMULATION_FOLLOW_UP = 'phishing-simulation-follow-up',
}
